const downloads = {
  modal: {
    chooseLanguage: Drupal.t('Choose your language'),
    emptyText: Drupal.t(
      'There are currently no Material Safety Data Sheets available for this product. Please reach out to us via <a href="@lang/node/49">contact form</a> to get yours.',
    ),
  },
  search: {
    // use ids from getDownloadsData return array
    1: Drupal.t('Search for Products'),
    2: Drupal.t('Search for Products'),
    3: Drupal.t('Search for Product Overviews'),
    4: Drupal.t('Search for Crop Folders'),
    5: Drupal.t('Search for Product Folders'),
    6: Drupal.t('Search for Downloads'),
  },
};

export default downloads;
